import request from 'umi-request';
import { environment } from './../../environment/environment';
import type { ApiResponse } from '../model/apiResponse';

export async function GetClient(token: string, clientId?: string | null): Promise<ApiResponse> {
  
  return await request(`/clients/${clientId}`, {
    method: 'GET',
    prefix: environment.baseUrl,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}